import { useContext, createContext } from 'react';

import { CookiesContextProps } from '../types';

// ------------------------------------------------

export const CookiesContext = createContext<CookiesContextProps | null>(null);

export const useCookiesContext = () => {
  const context = useContext(CookiesContext);

  if (!context) throw new Error('useCookiesContext must be use inside CookiesProvider');

  return context;
};
